import type { UI } from '@/v2/types';
import React from 'react';
import { Flex, StripeContentContainer } from '@qga/roo-ui/components';

import type { PackageOption as PackageOptionType } from '@shared/v2/utils/getPackageOptions/getPackageOptions';

import PackageHeroSummary from '@/components/PackageHeroSummary';
import PackageDetails from '@/v2/components/ui/PackageDetails';
import PackageOption from '@/v2/components/ui/PackageOption';
import { PackagePagePriceCashAndPointsOnly } from '../../PackagePagePrice';
import Departing from './Departing';
import PackageInclusions from './PackageInclusions';

interface Props {
  packageOption: PackageOptionType;
  isSelected?: boolean;
  onSelectPackageOption: (value: string) => void;
  procuredOffer: UI.ProcuredOffer | null;
  propertyContent: UI.Property;
  disabled: boolean;
}

const PackageOptionCard = ({
  packageOption,
  isSelected,
  onSelectPackageOption,
  propertyContent,
  procuredOffer,
  disabled,
}: Props) => {
  const { title, id, endDateMessage, inclusions, cheapestOffer } =
    packageOption;
  const { cheapestRoute } = cheapestOffer;
  const { nights, origin, price, travellers, displayTravellerTypes } =
    cheapestRoute;

  return (
    <PackageOption
      title={title}
      selected={isSelected}
      onClickCTA={() => onSelectPackageOption(id)}
      pillText={endDateMessage}
      disabled={disabled}
    >
      {price && (
        <StripeContentContainer variant="primary" flexDirection="column">
          <PackageHeroSummary showNights nights={nights} />
          <PackagePagePriceCashAndPointsOnly
            displayTravellerTypes={displayTravellerTypes}
            charges={price}
            travellers={travellers}
          />
          <Departing routeOriginName={origin?.name} />
        </StripeContentContainer>
      )}
      <Flex alignItems="flex-start" flexDirection="column" gap="12px" mb="24px">
        {inclusions && <PackageInclusions inclusions={inclusions} />}
        <PackageDetails
          propertyContent={propertyContent}
          procuredOffer={procuredOffer}
          inclusions={inclusions}
        />
      </Flex>
    </PackageOption>
  );
};

export default PackageOptionCard;
